// extracted by mini-css-extract-plugin
module.exports = {"products":"styles_products__7_NBo","label":"styles_label__tGWBg","tags":"styles_tags__CASU9","iconWrapper":"styles_iconWrapper__3YFaM"};